import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@blueprintjs/core';

// Pages to show around the current one: first, last, current ±1, with gaps
// collapsed to an ellipsis. Short runs are shown in full, so the bar never
// shows "…" in place of a single page.
function pageWindow(current, total) {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages = new Set([1, total, current - 1, current, current + 1]);
  if (current <= 4) [2, 3, 4, 5].forEach((p) => pages.add(p));
  if (current >= total - 3) [total - 4, total - 3, total - 2, total - 1].forEach((p) => pages.add(p));
  const sorted = [...pages].filter((p) => p >= 1 && p <= total).sort((a, b) => a - b);
  const items = [];
  sorted.forEach((page, i) => {
    if (i > 0 && page - sorted[i - 1] > 1) items.push(`gap-${page}`);
    items.push(page);
  });
  return items;
}

class Pagination extends Component {
  go(page) {
    const { value, total, onChange } = this.props;
    if (page >= 1 && page <= total && page !== value) onChange(page);
  }

  render() {
    const current = Number(this.props.value) || 1;
    const total = Number(this.props.total) || 0;
    if (total <= 1) return null;

    return (
      <nav className="page-nav" aria-label="Pagination">
        <button
          type="button"
          className="page-nav__step"
          onClick={() => this.go(current - 1)}
          disabled={current <= 1}
          aria-label="Previous page"
        >
          <Icon icon="chevron-left" iconSize={14} />
        </button>

        <ol className="page-nav__pages">
          {pageWindow(current, total).map((item) =>
            typeof item === 'string' ? (
              <li key={item} className="page-nav__gap" aria-hidden="true">
                …
              </li>
            ) : (
              <li key={item}>
                <button
                  type="button"
                  className={`page-nav__page${item === current ? ' is-current' : ''}`}
                  onClick={() => this.go(item)}
                  aria-current={item === current ? 'page' : undefined}
                  aria-label={`Page ${item}`}
                >
                  {item}
                </button>
              </li>
            )
          )}
        </ol>

        <span className="page-nav__summary">
          Page {current} of {total}
        </span>

        <button
          type="button"
          className="page-nav__step"
          onClick={() => this.go(current + 1)}
          disabled={current >= total}
          aria-label="Next page"
        >
          <Icon icon="chevron-right" iconSize={14} />
        </button>
      </nav>
    );
  }
}

Pagination.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
};

export default Pagination;
